/* Progressive enhancement: cards, hours, phone and directions work without JavaScript. */
if (!customElements.get('bd-store-locations')) {
  customElements.define('bd-store-locations', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.cards = Array.from(this.querySelectorAll('[data-location-card]'));
      this.search = this.querySelector('[data-location-search]');
      this.region = this.querySelector('[data-location-region]');
      if (!this.search || !this.region) return;
      this.region.querySelectorAll('[data-generated]').forEach(option => option.remove());
      [...new Set(this.cards.map(card => card.dataset.region).filter(Boolean))].sort().forEach(region => {
        const option = document.createElement('option');
        option.value = region; option.textContent = region; option.dataset.generated = '';
        this.region.append(option);
      });
      this.search.addEventListener('input', () => this.filter(), { signal });
      this.region.addEventListener('change', () => this.filter(), { signal });
      this.querySelectorAll('[data-location-reset]').forEach(button => button.addEventListener('click', () => {
        this.search.value = ''; this.region.value = ''; this.filter(); this.search.focus();
      }, { signal }));
      this.querySelectorAll('[data-location-map]').forEach(details => details.addEventListener('toggle', () => {
        if (!details.open) return;
        const frame = details.querySelector('iframe');
        if (!frame) return;
        if (frame.getAttribute('src')) { frame.hidden = false; return; }
        try {
          const url = new URL(frame.dataset.mapSrc);
          if (url.protocol !== 'https:' || !(url.hostname === 'google.com' || url.hostname.endsWith('.google.com'))) return;
          frame.src = url.href; frame.hidden = false;
        } catch { /* The directions link remains available if the saved embed URL is invalid. */ }
      }, { signal }));
      this.querySelector('[data-filters]').hidden = false;
      this.filter();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    normalize(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    filter() {
      const query = this.search.value.trim().replace(/^([a-z]\d[a-z])(\d[a-z]\d)$/i, '$1 $2');
      const terms = this.normalize(query).split(/\s+/).filter(Boolean);
      const region = this.region.value;
      let count = 0;
      this.cards.forEach(card => {
        const words = this.normalize(card.dataset.search).split(' ');
        const match = (!region || card.dataset.region === region) && terms.every(term => words.some(word => term.length <= 2 ? word === term : word.startsWith(term)));
        card.hidden = !match;
        if (match) count++;
      });
      this.querySelector('[data-location-count]').textContent = `${count} ${count === 1 ? 'location' : 'locations'}${terms.length || region ? ' found' : ''}`;
      this.querySelector('[data-location-empty]').hidden = count !== 0;
    }
  });
}
